import { getConfig } from "@jti/fe-common";

import { getIsEvo, getUser } from "../../../utils";

import type { CasAddressesApiContract } from "./CasAddressesApi.types";
import { CasAddressesApiEvo } from "./CasAddressesApiEvo";
import { CasAddressesApiLegacy } from "./CasAddressesApiLegacy";

export class CasAddressesApi {
  static init(): CasAddressesApiContract {
    const config = getConfig();
    const user = getUser();

    if (config.USE_EVO_ONLY) {
      return new CasAddressesApiEvo(
        config.EVO_DOMAIN,
        config.EVO_TENANT,
        user.ciam_token,
        config["X-RECAPTCHA-ID"],
        user.uuid || ""
      );
    }
    if (getIsEvo(config.CAS_URL)) {
      return new CasAddressesApiEvo(
        config.CAS_URL,
        config.CAS_X_DES_AK_TENANT_TOKEN,
        user.ciam_token,
        config["X-RECAPTCHA-ID"],
        user.uuid || ""
      );
    }
    return new CasAddressesApiLegacy(
      config.CAS_URL,
      config.CAS_X_DES_AK_TENANT_TOKEN,
      user.ciam_token,
      user.uuid || ""
    );
  }
}
